// Master JS for the Find a Meal Train page

import { WireupHandlers, SetLoadingState } from "./lib/data-wireup.js";
import { PostJSON } from "./lib/fetchers.js";
import { FormToObject } from "./lib/form-utilities.js";
import { WireupRecaptcha, ExecuteRecaptcha } from "./lib/recaptcha.js";

import { SubmitStatus } from "./webcomponents/submit-status.js";
import { RecentTrains } from "./webcomponents/recent-trains.js";

// Register required webcomponents
SubmitStatus.Register();
RecentTrains.Register();

WireupRecaptcha("recaptcha-container", onReCaptchaSubmit, "find-status");

// Note: we don't set the button loading state here because we have to wait until after recaptcha processes, in case they click out
WireupHandlers("find", "submit", async () => {
    SubmitStatus.Hide("find-status");
    ExecuteRecaptcha();
});

/**
 * On recaptcha success, look up the pasted link and go to the train
 */
async function onReCaptchaSubmit(token) {
    try {
        SetLoadingState("findsubmit", true);
        const form = document.querySelector("[data-wireup-find]");
        const result = await PostJSON("/find", { ...FormToObject(form), token });
        // Leave the button loading, since we're navigating away
        window.location = result.returnUrl;
    } catch (err) {
        SubmitStatus.Set("find-status", err.message, true);
        SetLoadingState("findsubmit", false);
    }
}
